"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var streams_1 = require("@moralisweb3/streams");
var api_utils_1 = require("@moralisweb3/api-utils");
var auth_1 = require("@moralisweb3/auth");
var evm_utils_1 = require("@moralisweb3/evm-utils");
var evm_api_1 = require("@moralisweb3/evm-api");
var sol_utils_1 = require("@moralisweb3/sol-utils");
var sol_api_1 = require("@moralisweb3/sol-api");
var core_1 = require("@moralisweb3/core");
// Core
var core = core_1.MoralisCore.create();
// Utility modules
var evmUtils = evm_utils_1.MoralisEvmUtils.create(core);
var solUtils = sol_utils_1.MoralisSolUtils.create(core);
var apiUtils = api_utils_1.MoralisApiUtils.create(core);
// Feature modules
var auth = auth_1.MoralisAuth.create(core);
var streams = streams_1.MoralisStreams.create(core);
var evmApi = evm_api_1.MoralisEvmApi.create(core);
var solApi = sol_api_1.MoralisSolApi.create(core);
// Register all Moralis modules to MoralisCore
core.registerModules([evmUtils, solUtils, auth, apiUtils, evmApi, solApi, streams]);
core_1.MoralisCoreProvider.setDefault(core);
var Moralis = {
    Core: core,
    Auth: auth,
    Streams: streams,
    EvmApi: evmApi,
    SolApi: solApi,
    start: core.start,
};
exports.default = Moralis;
